import { StyleSheet, View } from 'react-native';
import type { ViewProps } from 'react-native';

export interface BoxProps extends ViewProps {
  row?: boolean;
  flex?: number;
  center?: boolean;
  gap?: number;
  padding?: number;
}

export function Box({ row, flex, center, gap, padding, style, ...rest }: BoxProps) {
  return (
    <View
      style={[
        row === true && styles.row,
        center === true && styles.center,
        flex !== undefined && { flex },
        gap !== undefined && { gap },
        padding !== undefined && { padding },
        style,
      ]}
      {...rest}
    />
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row' },
  center: { alignItems: 'center', justifyContent: 'center' },
});
